import { render } from "./VideosGrid.vue?vue&type=template&id=ae0ab43c&scoped=true"
import script from "./VideosGrid.vue?vue&type=script&lang=js"
export * from "./VideosGrid.vue?vue&type=script&lang=js"

import "./VideosGrid.vue?vue&type=style&index=0&id=ae0ab43c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0ab43c"]])

export default __exports__